import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    SenderPayloadT,
    SendersCreateSenderResponseT,
    SendersGetListResponseT,
    SendersSearchSenderResponseT,
} from '../types/senders.types'

export class SendersRepository {
    getList(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<AxiosResponse<SendersGetListResponseT>> {
        const params = {
            page_number: page,
            company_id,
            city_id,
        }

        return http.get('/cabinet/api/sender', { params })
    }

    createSender(payload: SenderPayloadT): Promise<AxiosResponse<SendersCreateSenderResponseT>> {
        return http.post('/cabinet/api/sender', payload)
    }

    updateSender(
        id: number,
        payload: SenderPayloadT
    ): Promise<AxiosResponse<SendersCreateSenderResponseT>> {
        return http.put(`/cabinet/api/sender/${id}`, payload)
    }

    updateSenderInOrder(id: number, payload: SenderPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/senders/${id}`, payload)
    }

    deleteSender(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/sender/${id}`)
    }

    searchSender(
        param: string,
        company_id: number,
        exact_city_id?: number
    ): Promise<AxiosResponse<SendersSearchSenderResponseT>> {
        return http.post('/cabinet/api/sender/search', { param, company_id, exact_city_id })
    }
}
